
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/face_analyzer/eye_shape",
      function () {
        return require("private-next-pages/face_analyzer/eye_shape.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/face_analyzer/eye_shape"])
      });
    }
  